import React from "react";
// import "./Footer.scss";

function Footer() {
    return (
        <footer className="fixed-bottom">
            <div className="copyright">
                <span>&copy; 2026 CATVV</span>
            </div>
        </footer>
    );
}

export default Footer;
